define('modules/editor/models/custom_meta',['require','exports','module','backbone'],function(require, exports, module){
  "use strict";
  var Backbone = require("backbone");

  module.exports = Backbone.Model.extend({
    defaults: {
      name: "",
      value: ""
    }
  });
});

